// Auth-flow console logs must never dump a raw AxiosError: `error.config` carries the
// X-API-KEY header and, on refresh calls, the plaintext access/refresh tokens as `data`.
// PostHog's console-log capture ingests console.error args verbatim, so an unsanitized
// dump here leaks credentials into PostHog. Always log through this instead.
export function sanitizeErrorForLog(error: unknown): {
  message: string;
  status: number | null;
} {
  const err = error as { message?: string; response?: { status?: number } } | null;
  return {
    message: err?.message ?? String(error),
    status: err?.response?.status ?? null,
  };
}
